import React, {Component, Fragment} from 'react';
import {withRouter} from 'react-router-dom';
import {connect} from 'react-redux';
import ReactTooltip from 'react-tooltip';
import ftosActionCreators from '../../store/ftos/action-creators';
import Modal from '../../../shared/ui/Modal';
import LoadingOverlay from '../../../shared/components/LoadingOverlay';
import departmentSettingsSelectors from "../../store/department-settings/selectors";
import DisplayUserPhoto from "../users/DisplayUserPhoto";
import Tooltip from "../../../shared/ui/Tooltip";
import {ApiDelete, ApiGet, ApiPost} from "../../../shared/services/api-service";
import FtoComments from "../oits/FtoComments";
import TrainingNotesCreate from "../oits/TrainingNotesCreate";
import FtoCommentsCreate from "../oits/FtoCommentsCreate";
import {formatDate} from "../../../shared/services/utils/utils";
import moment from 'moment';

export const calculateTrainingDays = (assignment, rangeStart, rangeEnd) => {
  if (!assignment.openedAt || !rangeStart || !rangeEnd) {
    return 0;
  }

  const assignmentStart = moment(assignment.openedAt).startOf('day');
  const assignmentEnd = assignment.closedAt
    ? moment(assignment.closedAt).startOf('day')
    : moment().startOf('day');
  const selectedStart = moment(rangeStart).startOf('day');
  const selectedEnd = moment(rangeEnd).startOf('day');

  if (!assignmentStart.isValid() || !assignmentEnd.isValid() ||
    !selectedStart.isValid() || !selectedEnd.isValid()) {
    return 0;
  }

  const overlapStart = moment.max(assignmentStart, selectedStart);
  const overlapEnd = moment.min(assignmentEnd, selectedEnd);

  if (overlapEnd.isBefore(overlapStart)) {
    return 0;
  }

  const pausedDays = ((assignment.oit && assignment.oit.vacations) || []).reduce(
    (total, vacation) => {
      if (!vacation.start) {
        return total;
      }

      const vacationStart = moment(vacation.start).startOf('day');
      const vacationEnd = vacation.finish
        ? moment(vacation.finish).subtract(1, 'day').startOf('day')
        : moment().startOf('day');
      const pauseStart = moment.max(vacationStart, overlapStart);
      const pauseEnd = moment.min(vacationEnd, overlapEnd);

      return pauseEnd.isBefore(pauseStart)
        ? total
        : total + pauseEnd.diff(pauseStart, 'days') + 1;
    },
    0
  );

  return overlapEnd.diff(overlapStart, 'days') + 1 - pausedDays;
};

class ActiveFtos extends Component {
  constructor(props) {
    super(props);

    this.state = {
      currentFtoAssignments: null,
      currentFto: null,
      isModalOpened: false,
      searchWord: null,
      selectedFtoGuid: null,
      currentFtoComments: [],
      showFtoCommentsDialog: false,
      showAddTrainingNotesDialog: false,
      trainingPeriodMode: 'year',
      trainingYear: moment().year().toString(),
      trainingStartDate: '',
      trainingEndDate: '',
      sortBy: 'trainingDays',
      sortDirection: 'desc'
    };
  }

  componentDidMount() {
    this.props.fetchFtos();
  }

  get isLoading() {
    return this.props.isLoading.includes('fetchFtos');
  }

  viewFtoAssignments(fto) {
    let ftoAssignments = fto.currentTrainingPhases;
    this.setState({
      currentFtoAssignments: ftoAssignments,
      currentFto: fto,
      isModalOpened: true,
    });
  }

  openFtoComments(fto) {
    ApiGet(`api/v1/fto-comments/${fto.guid}`)
      .then(res => {
        this.setState({
          showFtoCommentsDialog: true,
          selectedFtoGuid: fto.guid,
          currentFtoComments: res
        })
      })
  }

  searchFtos(e) {
    const {value} = e.target;
    this.setState({searchWord: value});
  }

  closeModal() {
    this.setState({
      isModalOpened: false,
    });

    setTimeout(() => {
      this.setState({
        currentFtoAssignments: null,
      });
    }, 310);
  }

  saveComment(data) {
    return ApiPost(`api/v1/fto-comments`,{
      ...data,
      guid: this.state.selectedFtoGuid
    })
      .then(res => {
        this.setState({
          showAddTrainingNotesDialog: false,
          currentFtoComments: res
        })
      })
  }

  deleteComment(comment) {
    return ApiDelete(`api/v1/fto-comments/${comment.id}`)
      .then(res => {
        return ApiGet(`api/v1/fto-comments/${this.state.selectedFtoGuid}`)
          .then(res => {
            this.setState({
              currentFtoComments: res
            })
          })
      })
  }

  get filteredFtos() {
    if (!this.props.activeFtos) {
      return this.props.activeFtos;
    }

    const searchWord = this.state.searchWord && this.state.searchWord.toLowerCase();
    const ftos = searchWord
      ? this.props.activeFtos.filter(({firstName, lastName}) => {
        return (
          firstName.toLowerCase().includes(searchWord) ||
          lastName.toLowerCase().includes(searchWord)
        );
      })
      : this.props.activeFtos;

    return [...ftos].sort((a, b) => {
      const value = fto => this.state.sortBy === 'ongoingAssignments'
        ? (fto.currentTrainingPhases || []).filter(p => p.status === 'opened').length
        : this.trainingDaysForFto(fto);
      const difference = value(a) - value(b);
      return this.state.sortDirection === 'asc' ? difference : difference * -1;
    });
  }

  sortBy(property) {
    this.setState(({sortBy, sortDirection}) => ({
      sortBy: property,
      sortDirection: sortBy === property && sortDirection === 'desc' ? 'asc' : 'desc'
    }));
  }

  get areCommentsEnabled() {
    return this.props.userContext.hasScope(['ftoc', 'sup', 'cstaff', 'depadmin'])

  }

  get upcomingAssignments() {
    return this.state.currentFtoAssignments &&
      this.state.currentFtoAssignments.filter(p => p.status === 'pending')
  }
  get ongoingAssignments() {
    return this.state.currentFtoAssignments &&
      this.state.currentFtoAssignments.filter(p => p.status === 'opened')
  }
  get completedAssignments() {
    return this.state.currentFtoAssignments &&
      this.state.currentFtoAssignments.filter(p => p.status === 'completed')
  }

  get trainingDateRange() {
    const {trainingPeriodMode, trainingYear, trainingStartDate, trainingEndDate} = this.state;

    if (trainingPeriodMode === 'dateRange' && trainingStartDate && trainingEndDate) {
      return {
        start: trainingStartDate,
        end: trainingEndDate,
        isValid: !moment(trainingEndDate).isBefore(moment(trainingStartDate), 'day')
      };
    }

    if (trainingPeriodMode === 'dateRange' && (trainingStartDate || trainingEndDate)) {
      return {start: null, end: null, isValid: false};
    }

    const year = Number(trainingYear);
    if (!Number.isInteger(year) || year < 1) {
      return {start: null, end: null, isValid: false};
    }

    return {
      start: `${year}-01-01`,
      end: `${year}-12-31`,
      isValid: true
    };
  }

  trainingDaysForAssignments(assignments) {
    const {start, end, isValid} = this.trainingDateRange;
    if (!isValid || !assignments) {
      return 0;
    }

    return assignments.reduce(
      (total, assignment) => total + calculateTrainingDays(assignment, start, end),
      0
    );
  }

  trainingDaysForFto(fto) {
    return this.trainingDaysForAssignments(fto.currentTrainingPhases);
  }

  updateTrainingPeriod(field, value) {
    this.setState({[field]: value});
  }

  setTrainingPeriodMode(trainingPeriodMode) {
    this.setState({trainingPeriodMode});
  }

  render() {
    return (
      <Fragment>
        <div className="app-content-header">
          <h4 className="title">Active {this.props.ftoShortLabel}s</h4>
        </div>
        <div className="app-content dashboard">
          <LoadingOverlay isLoading={this.isLoading}>
            <form className="table-filters">
              <div className="form-group">
                <input
                  className="form-control"
                  type="text"
                  value={this.state.searchWord}
                  placeholder={"Search " + this.props.ftoShortLabel }
                  onChange={e => this.searchFtos(e)}
                />
              </div>
              <div className="form-group">
                <span>Training period</span>
                <div role="group" aria-label="Training period">
                  <button
                    className={`button small ${this.state.trainingPeriodMode === 'year' ? 'primary' : 'default'}`}
                    type="button"
                    aria-pressed={this.state.trainingPeriodMode === 'year'}
                    onClick={() => this.setTrainingPeriodMode('year')}
                  >
                    Year
                  </button>
                  <button
                    className={`button small ${this.state.trainingPeriodMode === 'dateRange' ? 'primary' : 'default'}`}
                    type="button"
                    aria-pressed={this.state.trainingPeriodMode === 'dateRange'}
                    onClick={() => this.setTrainingPeriodMode('dateRange')}
                  >
                    Date range
                  </button>
                </div>
              </div>
              {this.state.trainingPeriodMode === 'year' ? (
                <div className="form-group">
                  <label htmlFor="training-year">Training year</label>
                  <input
                    id="training-year"
                    className="form-control"
                    type="number"
                    min="1"
                    value={this.state.trainingYear}
                    onChange={e => this.updateTrainingPeriod('trainingYear', e.target.value)}
                  />
                </div>
              ) : (
                <Fragment>
                  <div className="form-group">
                    <label htmlFor="training-start-date">From</label>
                    <input
                      id="training-start-date"
                      className="form-control"
                      type="date"
                      value={this.state.trainingStartDate}
                      onChange={e => this.updateTrainingPeriod('trainingStartDate', e.target.value)}
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="training-end-date">To</label>
                    <input
                      id="training-end-date"
                      className="form-control"
                      type="date"
                      value={this.state.trainingEndDate}
                      onChange={e => this.updateTrainingPeriod('trainingEndDate', e.target.value)}
                    />
                  </div>
                </Fragment>
              )}
            </form>
            {!this.trainingDateRange.isValid && (
              <div className="alert alert-danger">Enter both dates, with the end date on or after the start date.</div>
            )}
            <div className="table-scrollable">
              <table className="table table-striped">
                <thead>
                <tr>
                  <th style={{width: "90px"}}>
                    <div className="header">
                      <span>Photo</span>
                    </div>
                  </th>
                  <th>
                    <div className="header">
                      <span>Fto name</span>
                    </div>
                  </th>
                  <th onClick={() => this.sortBy('ongoingAssignments')}>
                    <div className="header">
                      <span>Ongoing assignments</span>
                      {this.state.sortBy === 'ongoingAssignments' && (
                        <div className="filterActions">
                          <i className={`fa fa-angle-${this.state.sortDirection === 'asc' ? 'up' : 'down'}`}/>
                        </div>
                      )}
                    </div>
                  </th>
                  <th onClick={() => this.sortBy('trainingDays')}>
                    <div className="header">
                      <span>Training days</span>
                      {this.state.sortBy === 'trainingDays' && (
                        <div className="filterActions">
                          <i className={`fa fa-angle-${this.state.sortDirection === 'asc' ? 'up' : 'down'}`}/>
                        </div>
                      )}
                    </div>
                  </th>
                  <th>
                    <div className="header">
                      <span>Phone</span>
                    </div>
                  </th>
                  <th>
                    <div className="header">
                      <span data-tip data-for="fto-late-submissions">Late submissions (all time)</span>
                    </div>
                  </th>
                  <th>
                    <div className="header">
                      <span>Actions</span>
                    </div>
                  </th>
                </tr>
                </thead>
                <tbody>
                {this.filteredFtos &&
                this.filteredFtos.map((fto, index) => {
                  return (
                    <tr key={index.toString()}>
                      <td>
                        <DisplayUserPhoto
                          user={fto}
                        />
                      </td>
                      <td>
                        <DisplayUserPhoto
                          user={fto}
                          displayOnHover={true}
                        >
                          {fto.getFullName()}
                        </DisplayUserPhoto>
                      </td>
                      <td>{fto.currentTrainingPhases ? fto.currentTrainingPhases.filter(p => p.status === 'opened').length: 0}</td>
                      <td>{this.trainingDaysForFto(fto)}</td>
                      <td>
                        <i className="fa fa-phone"/> &nbsp;{' '}
                        {fto.getDefaultPhoneFormatted()}
                      </td>
                      <td>{fto.lateSubmissionCount}</td>
                      <td className="td-actions">
                       <Tooltip tip="View assignments">
                        <button
                          className="button small default"
                          data-tip="View assignments"
                          onClick={() =>
                            this.viewFtoAssignments(fto)
                          }
                        >
                            <span>
                              <i className="fa fa-address-card" />
                            </span>
                        </button>
                       </Tooltip>
                        {this.areCommentsEnabled && <Tooltip tip="View comments">
                          <button
                            className="button small default"
                            data-tip="Comments"
                            onClick={() =>
                              this.openFtoComments(fto)
                            }
                          >
                            <span>
                              <i className="fa fa-comment"/>
                            </span>
                          </button>
                        </Tooltip>}
                      </td>
                    </tr>
                  );
                })}
                </tbody>
              </table>
            </div>

          </LoadingOverlay>
          <ReactTooltip id="fto-late-submissions" place="top" className="customTheme" effect="solid">
            All submitted reports in this department, submitted at least 24 hours after the scheduled deadline
          </ReactTooltip>
          <Modal
            isOpen={this.state.isModalOpened}
            onClose={this.closeModal.bind(this)}
            title={`${this.state.currentFto? this.state.currentFto.getFullName(): 'Current assignments'}`}
          >
            <div className="modal-body">
              <div><h4>Ongoing assignments</h4></div>
              <div className="table-scrollable">
                <table className="table table-striped">
                  <thead>
                  <tr>
                    <th>
                      <div className="header">
                        <span>Oit full name</span>
                      </div>
                    </th>
                    <th>
                      <div className="header">
                        <span>Phase</span>
                      </div>
                    </th>
                    <th>
                      <div className="header">
                        <span>Opened at</span>
                      </div>
                    </th>
                    <th>
                      <div className="header">
                        <span>Projected end at</span>
                      </div>
                    </th>
                    <th>
                      <div className="header">
                        <span>Training days</span>
                      </div>
                    </th>
                  </tr>
                  </thead>
                  <tbody>
                  {this.state.currentFtoAssignments &&
                    this.ongoingAssignments.map((assignment, index) => (
                      <tr key={index.toString()}>
                        <td>
                          {`${assignment.oit.firstName} ${
                            assignment.oit.lastName
                          }`}
                        </td>
                        <td>{assignment.header}</td>
                        <td>{formatDate(assignment.openedAt)}</td>
                        <td>{assignment.projected_end ? formatDate(assignment.projected_end): ''}</td>
                        <td>{this.trainingDaysForAssignments([assignment])}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <br/>
              <div><h4>Upcoming assignments</h4></div>
              <div className="table-scrollable">
                <table className="table table-striped">
                  <thead>
                  <tr>
                    <th>
                      <div className="header">
                        <span>Oit full name</span>
                      </div>
                    </th>
                    <th>
                      <div className="header">
                        <span>Phase</span>
                      </div>
                    </th>
                    <th>
                      <div className="header">
                        <span>Projected start at</span>
                      </div>
                    </th>
                  </tr>
                  </thead>
                  <tbody>
                  {this.state.currentFtoAssignments &&
                    this.upcomingAssignments.map((assignment, index) => (
                      <tr key={index.toString()}>
                        <td>
                          {`${assignment.oit.firstName} ${
                            assignment.oit.lastName
                          }`}
                        </td>
                        <td>{assignment.header}</td>
                        <td>{assignment.projected_start ? formatDate(assignment.projected_start): ''}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              <br/>
              <div><h4>Completed assignments</h4></div>
              <div className="table-scrollable">
                <table className="table table-striped">
                  <thead>
                  <tr>
                    <th>
                      <div className="header">
                        <span>Oit full name</span>
                      </div>
                    </th>
                    <th>
                      <div className="header">
                        <span>Phase</span>
                      </div>
                    </th>
                    <th>
                      <div className="header">
                        <span>Started at</span>
                      </div>
                    </th>
                    <th>
                      <div className="header">
                        <span>Completed at</span>
                      </div>
                    </th>
                    <th>
                      <div className="header">
                        <span>Training days</span>
                      </div>
                    </th>
                  </tr>
                  </thead>
                  <tbody>
                  {this.state.currentFtoAssignments &&
                    this.completedAssignments.map((assignment, index) => (
                      <tr key={index.toString()}>
                        <td>
                          {`${assignment.oit.firstName} ${
                            assignment.oit.lastName
                          }`}
                        </td>
                        <td>{assignment.header}</td>
                        <td>{assignment.openedAt ? formatDate(assignment.openedAt): ''}</td>
                        <td>{assignment.closedAt ? formatDate(assignment.closedAt): ''}</td>
                        <td>{this.trainingDaysForAssignments([assignment])}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </Modal>

          <Modal
            isOpen={this.state.showFtoCommentsDialog}
            onClose={() => this.setState({showFtoCommentsDialog: false})}
            title="Comments"
          >
            {this.state.showFtoCommentsDialog && (
              <FtoComments
                userContext={this.props.userContext}
                comments={this.state.currentFtoComments}
                onAddNotes={() => this.setState({showAddTrainingNotesDialog: true})}
                deleteNote={(n) => this.deleteComment(n)}
              />
            )}
          </Modal>

          <Modal
            isOpen={ this.state.showAddTrainingNotesDialog}
            onClose={() => this.setState({showAddTrainingNotesDialog: false})}
            size="lg"
            title={`Add comments`}>
            { this.state.showAddTrainingNotesDialog && (
              <FtoCommentsCreate
                saveNoteAction={(data) => this.saveComment(data)}
                onSuccess={() => this.setState({
                  showAddTrainingNotesDialog: false,
                })}
              />
            )}
          </Modal>
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isLoading: state.ftos.isLoading,
    activeFtos: state.ftos.list,
    userContext: state.common.userContext,
    ftoShortLabel: departmentSettingsSelectors.ftoShortLabel(state),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchFtos: () => {
      return dispatch(ftosActionCreators.fetchFtos());
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ActiveFtos));
